import React, { useState } from "react";

const Certifications = () => {
  const certifications = [
    {
      title: "Microsoft Certified: Azure Fundamentals (AZ-900)",
      issuer: "Microsoft",
      link: "https://learn.microsoft.com/en-us/users/shreeyadineshdesai-6786/credentials/985ce2f29df56e95?ref=https%3A%2F%2Fwww.linkedin.com%2F",
    },
    {
      title: "Microsoft 365 Fundamentals (MS-900)",
      issuer: "Microsoft",
      link: "https://learn.microsoft.com/en-us/users/shreeyadineshdesai-6786/credentials/985ce2f29df56e95?ref=https%3A%2F%2Fwww.linkedin.com%2F",
    },
    {
      title: "Networking Basics",
      issuer: "Cisco Networking Academy",
      link: "https://www.credly.com/badges/f4528f37-0d74-4d07-85a5-76c0a1e9cb06/public_url",
    },
    {
      title: "Verizon Cloud Computing Job Simulation",
      issuer: "Forage",
      link: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Verizon%20Communications%20Inc./aNJGnRtgfiK5fQqcR_uu47f3odrfruEWjKw_iBAR6seXCk2tuWMbE_1730592993717_completion_certificate.pdf",
    },
    {
      title: "Datacom Introduction to Cloud",
      issuer: "Forage",
      link: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Datacom/qsuRRyXDZ7Dj2QFx4_Datacom_iBAR6seXCk2tuWMbE_1723383176747_completion_certificate.pdf",
    },
    {
      title: "Responsive Web Design",
      issuer: "FreeCodeCamp",
      link: "https://www.freecodecamp.org/certification/Shreeya_dinesh_desai/responsive-web-design",
    },
    {
      title: "CSS Certification",
      issuer: "HackerRank",
      link: "https://www.hackerrank.com/certificates/iframe/41bc4914ec74",
    },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section
      id="certifications"
      style={{
        padding: "80px 50px",
        background: "#000",
        color: "#fff",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "40px",
          fontSize: "2rem",
        }}
      >
        Certifications
      </h2>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {certifications.map((cert, index) => {
          const isHovered = hoveredIndex === index;
          return (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                flex: "1 1 calc(33% - 20px)",
                minWidth: "250px",
                background: isHovered ? "#00b894" : "rgba(255, 255, 255, 0.05)",
                color: isHovered ? "#fff" : "#fff",
                padding: "20px",
                borderRadius: "10px",
                transition: "all 0.3s ease",
                transform: isHovered ? "translateY(-5px)" : "translateY(0)",
              }}
            >
              <h3 style={{ marginBottom: "5px" }}>{cert.title}</h3>
              <p
                style={{
                  marginBottom: "10px",
                  color: isHovered ? "#fff" : "#d1d1d1",
                }}
              >
                Issued by: {cert.issuer}
              </p>
              <a
                href={cert.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: isHovered ? "#fff" : "#00b894",
                  textDecoration: "none",
                  fontWeight: "600",
                }}
              >
                View Credential →
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Certifications;
